import { render, staticRenderFns } from "./WpPrint.vue?vue&type=template&id=338b74a0&"
import script from "./WpPrint.vue?vue&type=script&lang=js&"
export * from "./WpPrint.vue?vue&type=script&lang=js&"
import style0 from "./WpPrint.vue?vue&type=style&index=0&id=338b74a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports